export default "__VITE_ASSET__Bm4fBbKf__"